import { render } from "./universitymanagement.vue?vue&type=template&id=051ac646&scoped=true"
import script from "./universitymanagement.vue?vue&type=script&lang=js"
export * from "./universitymanagement.vue?vue&type=script&lang=js"

import "./universitymanagement.vue?vue&type=style&index=0&id=051ac646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051ac646"]])

export default __exports__